import CryptoJS from 'crypto-js';

  // Frontend encryption
export const  encryptPasswordAES = (password) => {
    const passwordKey = "E6t187^D43%F";
    const passwordBytes = CryptoJS.enc.Utf8.parse(passwordKey);
    const passwordHash = CryptoJS.SHA256(passwordBytes);
    
    const saltBytes = CryptoJS.lib.WordArray.create([0x01020304, 0x05060708]);
    const keyAndIv = CryptoJS.PBKDF2(
        passwordHash, 
        saltBytes,
        {
            keySize: (256 + 128) / 32,
            iterations: 1000,
            hasher: CryptoJS.algo.SHA1
        }
    );
    const key = CryptoJS.lib.WordArray.create(keyAndIv.words.slice(0, 8)); 
    const iv = CryptoJS.lib.WordArray.create(keyAndIv.words.slice(8, 12));
    const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(password), 
        key,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );
    
    return encrypted.toString();
}